import { c as _c } from "react/compiler-runtime";
import IconPin from '@/components/assets/icon_pin.svg';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import ViverseCard from '@/components/ViverseCard';
import { useTranslations } from 'next-intl';
const UserFeaturedEmptyCard = () => {
  const $ = _c(12);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex size-10 items-center justify-center"><IconPin className="fill-vive-primary-20" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("profile-page.set-featured-world");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TooltipTrigger asChild={true}><ViverseCard className="h-[242px] max-w-[139px] cursor-default md:max-w-[340px] md:min-w-[340px] md:p-2 lg:max-w-[416px] lg:min-w-[416px]"><ViverseCard.Content className="bg-vive-white/10 flex min-h-[242px] w-full flex-col items-center justify-center gap-2 rounded-[7px] align-middle transition-all">{t0}<div className="subheader-3 md:subheader-2 text-vive-primary-20">{t1}</div></ViverseCard.Content></ViverseCard></TooltipTrigger>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("profile-page.set-featured-world-description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <TooltipContent side="bottom" sideOffset={20} className="bg-sidebar-primary"><p>{t3}</p></TooltipContent>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="md:-mx-2"><Tooltip>{t2}{t4}</Tooltip></div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default UserFeaturedEmptyCard;